/* Context rules are generated from the reviewed catalogue, never guessed in browser. */
(function(root,factory){const api=factory();if(typeof module==='object'&&module.exports)module.exports=api;else root.CCRecommendations=api;})(typeof window!=='undefined'?window:this,function(){
  function rank(graph,sourceIds,excludedIds=[],intent='complementary',nativeIds=[],context='cart'){
    const excluded=new Set([...sourceIds,...excludedIds].map(String));
    const ownedRoles=new Set(excludedIds.map(id=>graph.nodes[String(id)]?.role).filter(Boolean));
    const native=new Set(nativeIds.map(String));const pool=new Map();
    for(const [order,id]of sourceIds.entries()){
      const node=graph.nodes[String(id)];if(!node)continue;
      for(const edge of node[intent]||[]){
        const target=graph.nodes[String(edge.id)];if(!target||excluded.has(String(edge.id)))continue;
        if((context==='cart'||intent==='complementary')&&ownedRoles.has(target.role))continue;
        const prior=pool.get(String(edge.id));
        const score=edge.score+(native.has(String(edge.id))?6:0);
        if(!prior||score>prior.score)pool.set(String(edge.id),{...edge,score,sourceId:id,sourceOrder:order,sourceFamily:node.family,node:target});
      }
    }
    return [...pool.values()].sort((a,b)=>b.score-a.score||a.sourceOrder-b.sourceOrder||a.id-b.id);
  }
  function choose(ranked,products,limit=3,intent='complementary'){
    const roles=new Set(),families=new Set(),used=new Set(),result=[];
    const valid=ranked.filter(edge=>{const p=products.get(String(edge.id));return p&&p.available&&p.variants?.some(v=>v.available);});
    const take=edge=>{if(used.has(edge.id)||(intent==='complementary'&&roles.has(edge.node.role)))return false;result.push({...edge,product:products.get(String(edge.id))});roles.add(edge.node.role);families.add(edge.sourceFamily);used.add(edge.id);return true;};
    // A mixed basket receives a useful addition for each represented usage before filling extra slots.
    if(intent==='complementary')for(const edge of valid){if(!families.has(edge.sourceFamily))take(edge);if(result.length>=limit)return result;}
    for(const edge of valid){take(edge);if(result.length>=limit)break;}
    return result;
  }
  return {rank,choose};
});

(() => {
  if(customElements.get('cc-recommendations'))return;
  const graphCache=new Map(),productCache=new Map(),nativeCache=new Map();
  const root=()=>window.Shopify?.routes?.root||'/';
  const json=async url=>{const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),5000);try{const r=await fetch(url,{headers:{Accept:'application/json'},signal:controller.signal});if(!r.ok)throw new Error('Unavailable');return await r.json();}finally{clearTimeout(timer);}};
  const memo=(cache,key,fn)=>{if(!cache.has(key))cache.set(key,Promise.resolve().then(fn).catch(e=>{cache.delete(key);throw e;}));return cache.get(key);};
  const english=()=>document.documentElement.lang.startsWith('en');
  const el=(tag,cls,text)=>{const n=document.createElement(tag);if(cls)n.className=cls;if(text!==undefined)n.textContent=text;return n;};
  function internalURL(raw,handle){
    try{const u=new URL(raw||`${root()}products/${encodeURIComponent(handle)}`,location.origin);if(u.origin===location.origin&&u.pathname.startsWith(root()+'products/'))return u.pathname+u.search;}catch(_){}
    return root()+'products/'+encodeURIComponent(handle);
  }
  class CCRecommendations extends HTMLElement{
    connectedCallback(){
      this.version=(this.version||0)+1;this.hidden=false;
      if('IntersectionObserver'in window){this.observer=new IntersectionObserver(entries=>{if(entries.some(x=>x.isIntersecting)){this.observer.disconnect();this.load();}},{rootMargin:'120px'});this.observer.observe(this);}else this.load();
    }
    disconnectedCallback(){this.version++;this.observer?.disconnect();}
    async load(){
      const version=this.version;
      try{
        const ids=JSON.parse(this.dataset.sources||'[]');if(!ids.length){this.hidden=true;return;}
        const excluded=JSON.parse(this.dataset.exclude||'[]');
        const intent=this.dataset.intent||'complementary';const context=this.dataset.context||'product';
        const graph=await memo(graphCache,this.dataset.graph,()=>json(this.dataset.graph));
        // Native order is a modest boost only after catalogue compatibility gates.
        const native=await Promise.all(ids.slice(0,3).map(id=>memo(nativeCache,root()+id+'related',()=>json(`${root()}recommendations/products.json?product_id=${encodeURIComponent(id)}&intent=related&limit=10`)).catch(()=>({products:[]}))));
        const nativeRows=native.flatMap(x=>x.products||[]);const nativeIds=nativeRows.map(x=>x.id);
        const ranked=window.CCRecommendations.rank(graph,ids,excluded,intent,nativeIds,context);
        if(!ranked.length){this.hidden=true;return;}
        const products=new Map();
        // Bounded requests; no full-catalogue product fetch. Later candidates rescue out-of-stock items.
        for(let start=0;start<Math.min(ranked.length,18);start+=6){
          await Promise.all(ranked.slice(start,start+6).map(async e=>{
            try{const p=await memo(productCache,root()+e.node.handle,()=>json(root()+'products/'+encodeURIComponent(e.node.handle)+'.js'));if(String(p.id)===String(e.id))products.set(String(e.id),p);}catch(_){}
          }));
          if(window.CCRecommendations.choose(ranked,products,Number(this.dataset.limit)||3,intent).length>=(Number(this.dataset.limit)||3))break;
        }
        const chosen=window.CCRecommendations.choose(ranked,products,Number(this.dataset.limit)||3,intent);
        if(!this.isConnected||version!==this.version)return;if(!chosen.length){this.hidden=true;return;}
        const grid=el('div','cc-cross-sell__grid');
        for(const row of chosen){
          const p=row.product,nativeProduct=nativeRows.find(x=>String(x.id)===String(p.id));
          const article=el('article','cc-cross-sell__card');article.dataset.ccRecommendationId=p.id;
          const url=internalURL(nativeProduct?.url||p.url,p.handle);
          const imageLink=el('a','cc-cross-sell__image');imageLink.href=url;
          const nativeMediaReady=['9798791987536','9635816800592'].includes(String(p.id));const override=nativeMediaReady?null:(english()?row.node?.imageAssetEn:row.node?.imageAsset); if(override||p.featured_image){const img=el('img');let src=override?new URL(override,new URL(this.dataset.graph,location.href)).href:(typeof p.featured_image==='string'?p.featured_image:p.featured_image.src);try{const u=new URL(src,location.origin);if(['https:','http:'].includes(u.protocol)){u.searchParams.set('width','450');img.src=u.href;img.alt=p.title;img.width=450;img.height=450;img.loading='lazy';img.decoding='async';imageLink.append(img);}}catch(_){}}
          const detail=el('div','cc-cross-sell__details'),title=el('a','cc-cross-sell__title',p.title);title.href=url;
          const currency=this.dataset.currency||window.Shopify?.currency?.active;
          const amount=Number(p.price_min??p.price)/100;
          const price=el('span','cc-cross-sell__price');
          if(Number.isFinite(amount)&&currency){try{price.textContent=(p.price_varies?(english()?'From ':'Dès '):'')+new Intl.NumberFormat(document.documentElement.lang,{style:'currency',currency}).format(amount);}catch(_){}}
          detail.append(title,price);
          const simple=p.variants.length===1&&p.variants[0].title==='Default Title';
          if(context==='cart'&&simple){const variant=p.variants.find(v=>v.available),form=el('form','cc-cross-sell__form');form.method='post';form.action=root()+'cart/add';
            for(const [name,value]of [['id',variant.id],['quantity',1]]){const input=el('input');input.type='hidden';input.name=name;input.value=value;form.append(input);}
            const button=el('button','',english()?'Add':'Ajouter');button.type='submit';const error=el('p','cc-cross-sell__error');error.setAttribute('role','alert');error.hidden=true;form.append(button,error);detail.append(form);
          }else{const choose=el('a','cc-cross-sell__choose',english()?'Choose':'Choisir');choose.href=url;detail.append(choose);}
          article.append(imageLink,detail);grid.append(article);
        }
        const heading=el('h2','',intent==='similar'?(english()?'In the same spirit':'Dans le même univers'):(english()?'Useful together':'Les bons compléments'));
        this.replaceChildren(heading,grid);this.hidden=false;
      }catch(_){if(this.isConnected&&version===this.version)this.hidden=true;/* Native forms remain available. */}
    }
  }
  customElements.define('cc-recommendations',CCRecommendations);
  let cartSyncVersion=0,cartSyncTimer;
  const scheduleCartSync=()=>{clearTimeout(cartSyncTimer);cartSyncTimer=setTimeout(async()=>{
    const version=++cartSyncVersion;
    try{const cart=await json(root()+'cart.js');if(version!==cartSyncVersion)return;
      const ids=[...new Set((cart.items||[]).map(item=>item.product_id))];
      for(const host of document.querySelectorAll('cc-recommendations')){
        host.dataset.exclude=JSON.stringify(ids);
        if(host.dataset.context==='cart')host.dataset.sources=JSON.stringify(ids);
        host.version=(host.version||0)+1;host.load();
      }
    }catch(_){}
  },50);};
  document.addEventListener('cart:updated',scheduleCartSync);
  const bindCartUpdates=()=>{if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,scheduleCartSync);};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bindCartUpdates,{once:true});else bindCartUpdates();

})();

/* One delegated handler survives native Shopify cart section replacements. */
(() => {
  if (window.ccCrossSellReady) return;
  window.ccCrossSellReady = true;
  // Native drawer quantity updates replace its whole inner region. External
  // cart publishers may refresh only items/footer: keep the extras in sync too.
  let refreshVersion = 0;
  const refreshExtras = async (event = {}) => {
    const version = ++refreshVersion;
    if (!document.querySelector('[data-cc-cart-extras]')) return;
    try {
      let markup = event.cartData?.sections?.['cart-drawer'];
      if (!markup) {
        const url = new URL(window.location.href);
        url.searchParams.delete('sections');
        url.searchParams.set('section_id', 'cart-drawer');
        const response = await fetch(url, {headers: {Accept: 'text/html'}});
        if (!response.ok) return;
        markup = await response.text();
      }
      if (version !== refreshVersion) return;
      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      for (const selector of ['[data-cc-cart-extras]', '[data-cc-cart-shipping]']) {
        const source = parsed.querySelector(selector);
        const target = document.querySelector(selector);
        if (source && target) target.replaceWith(source);
      }
    } catch (_) {
      // Cart actions retain their native error UI; never interrupt checkout.
    }
  };
  const subscribeToCart = () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshExtras);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', subscribeToCart, {once: true});
  else subscribeToCart();
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.cc-cross-sell__form');
    if (!form) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    event.preventDefault();
    const button = form.querySelector('button');
    if (button.disabled) return;
    const error = form.querySelector('[role="alert"]');
    error.hidden = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const data = new FormData(form);
    data.set('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
    data.set('sections_url', window.location.pathname);
    try {
      const response = await fetch(form.action + '.js', {method:'POST', body:data, headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || '');
      drawer.setActiveElement(button);
      drawer.renderContents(result);
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (failure) {
      error.textContent = failure.message || (document.documentElement.lang.startsWith('en') ? 'Unable to add this item. Please try again.' : 'Ajout impossible. Veuillez réessayer.');
      error.hidden = false;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
